import View from './view';
import events from '../events';
import {target} from '../utils/dom';

const opts = {
	el: null,
	loop: false,
	previousSelector: '[data-slider-previous]',
	nextSelector: '[data-slider-next]',
	slideSelector: '[data-slider-slide]',
	scrollerSelector: '[data-slider-scroller]',
	anchorSelector: '[data-slider-anchor]',
	start: 0,
	move: false,
	fullwidth: false
};

class Slider extends View {
	constructor(options) {
		super(options, opts);
		this.current = this.params.start;
	}

	start() {
		super.start();

		this.previous = this.el.query(this.params.previousSelector);
		this.next = this.el.query(this.params.nextSelector);
		this.slides = this.el.queryAll(this.params.slideSelector);
		this.scroller = this.el.query(this.params.scrollerSelector);
		this.anchors = this.el.queryAll(this.params.anchorSelector);
		this.isMove = this.el.getAttribute('data-slider') === 'move' || this.params.move;
		this.isFullWidth = this.el.getAttribute('data-slider-fullwidth') || this.params.fullwidth;
		this.isLoop = this.el.getAttribute('data-slider-loop') || this.params.loop;
		this.hasRemote = this.anchors.length > 0;

		this.el.addEventListener('click', event => this.click(event));
		//this.touch('swiperight', this.goPrevious.bind(this));
		//this.touch('swipeleft', this.goNext.bind(this));
		if (this.isMove) {
			events.on('resize', this.resize.bind(this));
			this.setWidth();
		}

		if (this.isLoop) {
			if (this.slides.length <= 1) {
				this.hideButton(this.previous);
				this.hideButton(this.next);
			} else {
				this.showButton(this.previous);
				this.showButton(this.next);
			}
		}

		this.goto(this.current);
	}

	click(event) {
		if (target(event.target, this.previous)) {
			this.goPrevious();
			return;
		}

		if (target(event.target, this.next)) {
			this.goNext();
			return;
		}

		let anchor = target(event.target, this.params.anchorSelector);
		if (anchor) {
			let index = Array.prototype.indexOf.call(this.anchors, anchor);
			this.goto(index);
		}
	}

	goPrevious() {
		let index = parseInt(this.current, 10) - 1;
		this.goto(index);
	}

	goNext() {
		let index = parseInt(this.current, 10) + 1;
		this.goto(index);
	}

	goto(ind) {
		let index = ind;
		if (index && index.nodeType) {
			index = this.getIndexFromSlide(index);
		}
		if (index < 0) {
			index = this.isLoop ? this.slides.length - 1 : 0;
		}
		if (index >= this.slides.length) {
			index = this.isLoop ? 0 : this.slides.length - 1;
		}

		this.slides[this.current].classList.remove('active');
		this.current = index;
		this.slides[this.current].classList.add('active');

		if (this.isMove) {
			this.moveTo(this.current);
		}

		this.checkRemote();
		this.events.emit('goto', index);
	}

	moveTo(index) {
		let slide = this.slides[index];
		let to = this.getPosition(slide);
		this.scroller.style.left = `${to}px`;

		return slide;
	}

	getPosition(slide) {
		return -slide.offsetLeft;
	}

	getIndexFromSlide(slide) {
		let i = 0;
		for (let s of this.slides) {
			if (s === slide) {
				return i;
			}
			i++;
		}
	}

	checkRemote() {
		let index = this.current;

		if (!this.isLoop) {
			if (index <= 0) {
				this.hideButton(this.previous);
			} else {
				this.showButton(this.previous);
			}

			if (index >= this.slides.length - 1) {
				this.hideButton(this.next);
			} else {
				this.showButton(this.next);
			}
		}

		if (this.hasRemote) {
			this.anchors.forEach(anchor => anchor.classList.remove('active'));
			this.anchors[index].classList.add('active');
		}
	}

	showButton(button) {
		button.classList.add('active');
	}

	hideButton(button) {
		button.classList.remove('active');
	}

	setWidth() {
		let allWidth = 0;
		if (this.isFullWidth) {
			let width = this.el.offsetWidth;
			this.slides.forEach((slide) => {
				slide.style.width = `${width}px`;
				allWidth += width;
			});
		} else {
			this.slides.forEach((slide) => {
				allWidth += slide.offsetWidth;
			});
		}
		this.scroller.style.width = `${allWidth}px`;
	}

	resize() {
		this.setWidth();
		this.goto(this.current);
	}
}

document.queryAll('.slx-slider').forEach((item) => {
	const slider = new Slider({
		el: item
	});
	slider.start();
});

export default Slider;
